export default "__VITE_ASSET__Yi3jUrqr__"